import { useEffect, useState } from "react";
import "./settings.css";
import ThemePicker from "../../Custom/ThemePicker/ThemePicker";
import Button from "../../Custom/Button/Button";
import SegmentList from "../Segment/SegmentList";

const Settings = ({ list }) => {
  const [selectedSettings, setSelectedSettings] = useState(null);

  const handleSelected = (set) => {
    if (selectedSettings?.name === set.name) {
      setSelectedSettings(null);
    } else setSelectedSettings(set);
  };

  const handleScrollTop = (indexNonActive, indexActive) => {
    const wrapper = document.querySelector(".container-settings");
    const buttonTaskbar = document.querySelectorAll(".button-taskbar-settings")[
      indexNonActive
    ];

    wrapper.scrollTo(
      0,
      indexActive * buttonTaskbar.getBoundingClientRect().height
    );
  };

  useEffect(() => {
    if (selectedSettings !== null) {
      const indexCurrent = list
        .map((item) => item.name)
        .indexOf(selectedSettings.name);
      let indexNonActive;
      if (indexCurrent === list.length - 1) {
        indexNonActive = indexCurrent - 1;
      } else {
        indexNonActive = indexCurrent + 1;
      }
      handleScrollTop(indexNonActive, indexCurrent);
    }
  }, [selectedSettings]);

  return (
    <div className="container-settings">
      {list.map((item, index) => {
        return (
          <div className="button-taskbar-settings-wrapper" key={index}>
            <div
              className="button-taskbar-settings"
              key={index}
              onClick={() => handleSelected(item)}
            >
              <Button
                active={selectedSettings?.name === item.name ? true : false}
              >
                <span className="button-taskbar-settings-span">
                  {item.name}
                </span>
              </Button>
            </div>
            {selectedSettings?.name === item.name && (
              <div className="current-settings">
                {index === 1 && <ThemePicker />}
                {index === 0 && <SegmentList />}
              </div>
            )}
          </div>
        );
      })}
      {selectedSettings && <div className="scroll-navbar"></div>}
    </div>
  );
};

export default Settings;
